import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OptionQuery, OptionQueryListData, OptionQueriesState } from '../../types/optionQueries.types';

const initialState: OptionQueriesState = {
  queries: [],
  selectedQuery: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  sort: {
    field: 'createdAt',
    order: 'desc',
  },
};

const optionQueriesSlice = createSlice({
  name: 'optionQueries',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setQueries(state, action: PayloadAction<OptionQueryListData>) {
      state.queries = action.payload.queries;
      state.pagination.totalPages = action.payload.totalPages;
      state.pagination.totalRecords = action.payload.totalRecords;
      state.pagination.hasMorePages = action.payload.hasMorePages;
    },
    setSelectedQuery(state, action: PayloadAction<OptionQuery | null>) {
      state.selectedQuery = action.payload;
    },
    clearSelectedQuery(state) {
      state.selectedQuery = null;
    },
    setPage(state, action: PayloadAction<number>) {
      state.pagination.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pagination.pageSize = action.payload;
      state.pagination.page = 1;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSort(state, action: PayloadAction<{ field: string; order: string }>) {
      state.sort = action.payload;
      state.pagination.page = 1;
    },
    addQuery(state, action: PayloadAction<OptionQuery>) {
      state.queries.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateQuery(state, action: PayloadAction<OptionQuery>) {
      const index = state.queries.findIndex((q) => q.id === action.payload.id);
      if (index !== -1) {
        state.queries[index] = action.payload;
      }
    },
    removeQuery(state, action: PayloadAction<string>) {
      state.queries = state.queries.filter((q) => q.id !== action.payload);
      state.pagination.totalRecords -= 1;
    },
  },
});

export const {
  setLoading,
  setError,
  setQueries,
  setSelectedQuery,
  clearSelectedQuery,
  setPage,
  setPageSize,
  setSearch,
  setSort,
  addQuery,
  updateQuery,
  removeQuery,
} = optionQueriesSlice.actions;

export default optionQueriesSlice.reducer;
